// Rank-based styling for Champion photo rings + Qgiv-style rosette medallions.
// Only the top 5 get a medallion (matching the Qgiv leaderboard); 6th+ have none.
const BADGE_NAME = { 1: "first", 2: "second", 3: "third", 4: "fourth", 5: "fifth" };
const TOP = {
  1: "#C9A24C",
  2: "#9AA3AD",
  3: "#B07B4F",
  4: "#3E6B5E",
  5: "#4E9463",
};

export const ordinal = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const getRankStyle = (rank) => {
  if (TOP[rank]) {
    const c = TOP[rank];
    return {
      isTop: true,
      color: c,
      badgeSvg: `/badges/${BADGE_NAME[rank]}.svg`,
      ringStyle: { boxShadow: `0 0 0 3px #FBF7EF, 0 0 0 6px ${c}` },
    };
  }
  return {
    isTop: false,
    color: "#B08A2E",
    badgeSvg: null,
    ringStyle: { boxShadow: "0 0 0 3px #FBF7EF, 0 0 0 5px rgba(201,162,76,0.45)" },
  };
};
